import { AbstractControl } from '@angular/forms';

export function SmsValidChars(control: AbstractControl) {
    if ((/[^0123456789abcdefghijklmnopqrstuvwxyzñABCDEFGHIJKLMNOPQRSTUVWXYZ-_,.¿?¡!"@${}%&/+*\':;<>= ]/).test(control.value)) {
        return { valid: false };
    }
    return null;
}
